var map = {
	"./partner-badge-base-small.png": 130,
	"./partner-badge-bronze-small.png": 131,
	"./partner-badge-gold-small.png": 132,
	"./partner-badge-platinum-small.png": 133,
	"./partner-badge-silver-small.png": 134
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 129;